import { Injectable } from "@angular/core";
import{ Http, Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';

@Injectable()
export class FilemakerService {
    public url;

    constructor(private _http: Http){
        this.url=GLOBAL.url
    }

    guardarExpediente(draft){

        console.log(draft)
        let headers = new Headers({
            'Content-type': 'application/json',
            'Authorization': sessionStorage.getItem("token-domCloud")
        })
        
        return this._http.post(this.url+'save/exp', draft,{headers: headers})
        .pipe(map(res => res.json()));
    }
}